import { render, staticRenderFns } from "./CDFTransactionData.vue?vue&type=template&id=12292739"
import script from "./CDFTransactionData.vue?vue&type=script&lang=js"
export * from "./CDFTransactionData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports